import { gql } from '@apollo/client';

export const GET_ACTIVE_DOCUMENTS = gql`
  query GetDocuments($studyId: String, $carePlanId: String) {
    getActiveDocuments(studyId: $studyId, carePlanId: $carePlanId) {
      uuid
      studyId
      patientId
      carePlanId
      careActivityId
      typeId
      name
      status
    }
  }
`;

export const GET_LATEST_ACTIVE_DOCUMENT = gql`
  query GetDocument(
    $studyId: String
    $carePlanId: String
    $careActivityId: String
    $typeId: UUID!
  ) {
    getLatestActiveDocument(
      studyId: $studyId
      carePlanId: $carePlanId
      careActivityId: $careActivityId
      typeId: $typeId
    ) {
      uuid
      studyId
      patientId
      carePlanId
      careActivityId
      typeId
      name
      status
      base64File
      fileType
    }
  }
`;

export const GET_DOCUMENT_TYPES = gql`
  query GetDocumentTypes {
    getAllDocumentTypes {
      uuid
      name
      description
    }
  }
`;
